import type { Team } from '../../api/teams'
import { useActiveTeam } from '../../contexts/ActiveTeamContext'
import { useTeamsEnabled } from '../teams/useTeamsEnabled'
import { canViewTeamCredits } from './creditVisibility'

export type ActiveWallet =
  | { kind: 'personal'; team: null; canViewFinancials: true }
  | { kind: 'team'; team: Team; canViewFinancials: boolean }

/** The caller's own personal team is personal; invited personal teams are separate wallets. */
export function useActiveWallet(): ActiveWallet {
  const { activeTeam, personalTeam } = useActiveTeam()
  const enabled = useTeamsEnabled()
  if (!enabled || !activeTeam || activeTeam.id === personalTeam?.id) {
    return { kind: 'personal', team: null, canViewFinancials: true }
  }
  return { kind: 'team', team: activeTeam, canViewFinancials: canViewTeamCredits(activeTeam) }
}
